class PredictiveSearch extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector('#predictive-search')
    this.searchSpinner = this.querySelector('.predictive-search-spinner')

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event)
    }, 300).bind(this))
  }

  onChange () {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close()
      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults (searchTerm) {
    // Show the spinner
    if (this.predictiveSearchResults.innerHTML === '' || this.predictiveSearchResults.style.display === 'none') {
      this.searchSpinner.classList.add('show')
    }
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=query,product,collection&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        this.predictiveSearchResults.innerHTML = resultsMarkup
        this.open()
      })
      .catch((error) => {
        this.close()
        throw error
      })
      .finally(() => {
        // Hide the spinner no matter what
        this.searchSpinner.classList.remove('show')
      })
  }

  open () {
    this.predictiveSearchResults.style.display = 'block'
  }

  close () {
    this.predictiveSearchResults.style.display = 'none'
  }

  debounce (fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}
customElements.define('predictive-search', PredictiveSearch)
